import React, { useRef, useState, useEffect } from "react";

import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";

const EmployeeForm = (props) => {

  const attachmentFolder=localStorage.getItem("attachmentFolder");
  const addressRef = useRef({});
  const frmRef = useRef({});
  const bankRef = useRef({});

  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();
  const [addressDetails, setAddressDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [bankClose, setBankClose] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const [addressTypeId, setAddressTypeId] = useState();
  const [empType, setEmpType] = useState("Employee");
  const [empId, setEmpId] = useState(0);

  const [employeeData, setEmployeeData] = useState([]);

  const [filteredEmployeeData, setFilteredEmployeeData] = useState([]);

  const [designationData, setDesignationData] = useState([]);
  const [designationId, setDesignationId] = useState(0);
  const [departmentData, setDepartmentData] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [level, setLevel] = useState(0);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  var d = new Date();
  var dateString =
    d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();

  const uploadProImage = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/employee/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setBackImage(`${process.env.REACT_APP_FILE_URL}${data.url}`);
        setprofileUrl(data.url);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: getDesignation } = useHttp();
  const { sendRequest: getDepartment } = useHttp();
  const { sendRequest: getLocation } = useHttp();

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("setEmployeeData", data);
        setEmployeeData(data.output);
        console.log("level", level);

        if (level > 0) {
          const filteredEmployees = data.output.filter(
            (emp) => parseInt(emp.level) < parseInt(level)
          );

          console.log(filteredEmployees);

          setFilteredEmployeeData(filteredEmployees);
        } else {
          setFilteredEmployeeData(data.output);
        }
      }
    );
  }, [getEmp]);
  useEffect(() => {
    getDesignation(
      {
        url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log(data);
        setDesignationData(data);
      }
    );
  }, [getDesignation]);
  useEffect(() => {
    getDepartment(
      {
        url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        setDepartmentData(data);
      }
    );
  }, [getDepartment]);

  const { sendRequest: getWarehouseData } = useHttp();

  useEffect(() => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setLocationData(res);
        }
      }
    );
  }, []);

  const { sendRequest: postAddUser } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    if (addressDetails && addressDetails.length == 0) {
      toast.error("Please add atleast one Address.");
      return;
    }

    var grossSalary = frmRef.current.grossSalary.value;
    var perDaySalary = 0;
    if (frmRef.current.employee_type.value == "Labour") {
      grossSalary = 0;
      perDaySalary = frmRef.current.grossSalary.value;
    }

    const data = {
      employeeName: frmRef.current.employee_name.value.trim(),
      orgId: localStorage.getItem("orgId"),
      gender: frmRef.current.gender.value,
      whatsappNo: frmRef.current.whatsapp_number.value,
      contactNo: frmRef.current.whatsapp_number.value,
      departmentId: frmRef.current.department.value,
      designationId: frmRef.current.designation.value,
      profileurl: profileUrl,
      reportingId: frmRef.current.reporting_emp.value,
      birthDate: moment(frmRef.current.dob.value).format("DD/MM/YYYY"),
      address: addressDetails,
      emailId: frmRef.current.email.value,
      dateofJoining: moment(frmRef.current.doj.value).format("DD/MM/YYYY"),
      employeeType: frmRef.current.employee_type.value,
      employmentType: frmRef.current.employment_type.value,
      warehouseId: frmRef.current.location.value,
      grossSalary: grossSalary,
      perDaySalary: perDaySalary,
      workContactNo: frmRef.current.work_contact.value ?? 0,
      workEmailId: frmRef.current.work_email.value,
      idProof: frmRef.current.id_proof.value,
      bankDetail: bankDetails,
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: dateString,
      serviceId: props.sId,
    };
    console.log(data);
    if (props.update) {
      data["empId"] = props.update.empId;
    }
    postAddUser(
      {
        url: "/api/employeeDetail/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //  console.log(data);
        toast.success(
          `Employee ${props.update ? "Updated" : "Added"} successfully`
        );
        props.addForm(false);
      }
    );
  };
  const submitAddress = (e) => {
    e.preventDefault();

    if (!addressTypeId || addressTypeId === "0") {
      toast.error("Please select an Address Type.");
      return;
    }

    const existingAddress = addressDetails.find(
      (addr) => addr.addressType === addressTypeId
    );

    if (existingAddress) {
      toast.error(
        `${addressTypeId} already exists. You cannot add it multiple times.`
      );
      return;
    }

    if (addressTypeId !== "Permanent" && addressTypeId !== "Residential") {
      toast.error("Only 'Permanent' and 'Residential' addresses are allowed.");
      return;
    }

    var landmark = addressRef.current.landmark.value;
    var lga = addressRef.current.lga.value;
    var city = addressRef.current.city.value;
    var state = addressRef.current.state.value;
    var zipcode = addressRef.current.zipcode.value;
    var country = addressRef.current.country.value;
    var lat = latLong.lat;
    var lng = latLong.lng;


    setAddressDetails((x) => [
      ...x,
      {
        srno:
          addressDetails.length > 0
            ? addressDetails[addressDetails.length - 1].srno + 1
            : 1,
        addressType: addressTypeId,
        landmark: landmark,
        lga: lga,
        city: city,
        state: state,
        zipcode: zipcode,
        country: country,
        lat: lat,
        lng: lng,
      },
    ]);

    // Clear form inputs
    addressRef.current.landmark.value = "";
    addressRef.current.city.value = "";
    addressRef.current.state.value = "";
    addressRef.current.lga.value = "";
    addressRef.current.zipcode.value = "";
    addressRef.current.country.value = "";

    setAddressTypeId("");
  };

  const handleDelete = (index, e) => {
    setAddressDetails(addressDetails.filter((v, i) => i !== index));
  };

  // bank details
  const submitBankDetails = (e) => {
    e.preventDefault();
    var accNo = bankRef.current.account_number.value;
    const accNoExists =
      bankDetails && bankDetails.some((item) => item.accountNumber === accNo);

    if (accNoExists) {
      toast.error("Account number already exists");
      return;
    }

    setBankDetails((x) => [
      ...x,
      {
        srno:
          bankDetails.length > 0
            ? bankDetails[bankDetails.length - 1].srno + 1
            : 1,
        accountNumber: bankRef.current.account_number.value,
        accountHolderName: bankRef.current.acc_holder_name.value,
        ifscCode: bankRef.current.ifsc_code.value,
      },
    ]);

    //console.log(bankDetails);
  };

  const [latLong, setlatLong] = useState({
    lat: "",
    lng: "",
  });

    useEffect(() => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          //console.log(lat, long);
          setlatLong({ lat, lng });
        },
        (error) => {
          console.error(error);
        }
      );
    }, []);



  const [latlongclose, setLatlongclose] = useState(false);

  const handleLatLong = () => {
    setLatlongclose(true);
  };
  const handleDeleteBank = (index, e) => {
    setBankDetails(bankDetails.filter((v, i) => i !== index));
  };

  useEffect(() => {
    //   console.log(props.update);
    if (props.update) {
      frmRef.current.dob.value =
        props.update.birthDate &&
        props.update.birthDate.split("/").reverse().join("-");

      frmRef.current.doj.value =
        props.update.dateofJoining &&
        props.update.dateofJoining.split("/").reverse().join("-");

      frmRef.current.employee_name.value = props.update.employeeName;
      frmRef.current.contact_no.value = props.update.contactNo;
      frmRef.current.whatsapp_number.value = props.update.whatsappNo;
      frmRef.current.gender.value = props.update.gender;
      frmRef.current.email.value = props.update.emailId;
      frmRef.current.employee_name.value = props.update.employeeName;

      frmRef.current.work_email.value = props.update.workEmailId;
      frmRef.current.work_contact.value = props.update.workContactNo;
      frmRef.current.designation.value = props.update.designationId;

      const reportingEmp = props.update.reportingId || 0;
      console.log(employeeData);

      var empLevel = props.update.level;

      setLevel([...empLevel]);
      console.log("level", empLevel);
      console.log("emp", employeeData);

      // const filteredEmployees = employeeData.filter((emp) => emp.empId == reportingEmp);
      const filteredEmployees = employeeData.filter(
        (emp) => parseInt(emp.level) < parseInt(empLevel)
      );

      console.log(filteredEmployees);

      setFilteredEmployeeData(filteredEmployees);
      setEmpId(props.update.reportingId);
      frmRef.current.department.value = props.update.departmentId;
      frmRef.current.location.value = props.update.warehouseId;

      frmRef.current.employee_type.value = props.update.employeeType;
      frmRef.current.employment_type.value = props.update.employmentType;
      frmRef.current.id_proof.value = props.update.idProof;
      frmRef.current.grossSalary.value = props.update.grossSalary;

      setBackImage(
        `${process.env.REACT_APP_FILE_URL}${props.update.profileurl}`
      );
      setAddressDetails(props.update.address);
      setBankDetails(props.update.bankDetail);
      setprofileUrl(props.update.profileurl);
    }
  }, [props.update]);

  const handleDesignationChange = (e) => {
    const designationId = e.target.value || 0;
    const filterdDesignationId =
      designationData &&
      designationData.find(
        (elm) => parseInt(elm.designationId) === parseInt(designationId)
      );

    const empLevel = parseInt(filterdDesignationId?.level??"0") || 0;
    setLevel(empLevel);

    console.log("level", empLevel);
    console.log("emp", employeeData);

    let filteredEmployees = [];

    filteredEmployees = employeeData.filter(
      (emp) => parseInt(emp.level) < parseInt(empLevel)
    );
    console.log("filteredEmployees", filteredEmployees);

    setFilteredEmployeeData(filteredEmployees);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "500px",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      {latlongclose && (
        <Modal isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={latLong.lat}
            lng={latLong.lng}
            set={setlatLong}
            close={setLatlongclose}
          />
        </Modal>
      )}
      {/* address modal */}
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Employee Address</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"address_type"}>{"Address Type"}</label>

                <select
                  id="address_type"
                  className="form-control"
                  ref={(el) => (frmRef.current["address_type"] = el)}
                  value={addressTypeId}
                  onChange={(e) => {
                    setAddressTypeId(e.target.value);
                  }}
                >
                  <option value="0">Select</option>
                  <option>Permanent</option>
                  <option>Residential</option>|
                </select>
              </div>
              <div className="form-group">
                <label htmlFor={"state"}>State/Province</label>
                <input
                  type={"input"}
                  id={"state"}
                  required
                  ref={(el) => (addressRef.current["state"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"landmark"}>Address(landmark)</label>
                <input
                  type={"input"}
                  id={"landmark"}
                  required
                  ref={(el) => (addressRef.current["landmark"] = el)}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor={"zipcode"}>Zip Code(Postal</label>
                <input
                  type={"text"}
                  id={"zipcode"}
                  required
                  ref={(el) => (addressRef.current["zipcode"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"city"}>LGA</label>
                <input
                  type={"input"}
                  id={"lga"}
                  required
                  ref={(el) => (addressRef.current["lga"] = el)}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor={"country"}>Country</label>
                <input
                  type={"text"}
                  id={"country"}
                  required
                  ref={(el) => (addressRef.current["country"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"city"}>City</label>
                <input
                  type={"input"}
                  id={"city"}
                  required
                  ref={(el) => (addressRef.current["city"] = el)}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor={"lat_long"}>Lat/Long</label>
                <br />
                <button
                  onClick={(e) => {
                    handleLatLong(e);
                  }}
                  className="btn btn-sm btn-success"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-md-12">
              <button
                className="btn btn-sm btn-secondary"
                onClick={submitAddress}
              >
                +
              </button>
            </div>
          </div>

          <hr />
          <div className="flexRow">
            <table className="table table-bordered text-center table-sm">
              {" "}
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Address Type</th>
                  <th>Address(landmark)</th>
                  <th>LGA</th>
                  <th>City</th>
                  <th>State/Province</th>
                  <th>Zip Code</th>
                  <th>Country</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {addressDetails &&
                  addressDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.addressType}</td>
                        <td>{itm.landmark}</td>
                        <td>{itm.lga}</td>
                        <td>{itm.city}</td>
                        <td>{itm.state}</td>
                        <td>{itm.zipcode}</td>
                        <td>{itm.country}</td>

                        <td>
                          {" "}
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <button
              className="btn btn-primary"
              onClick={() => {
                addressDetails &&
                  addressDetails.map((x) => (x["isSave"] = true));

                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* end address modal */}
      {/* bank modal start */}
      {bankClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Employee Bank Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setBankClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"account_number"}>Account Number</label>

                <input
                  type={"input"}
                  id={"account_number"}
                  required
                  ref={(el) => (bankRef.current["account_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"acc_holder_name"}>Acc Holder Name</label>

                <input
                  type={"input"}
                  id={"acc_holder_name"}
                  required
                  ref={(el) => (bankRef.current["acc_holder_name"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"ifsc_code"}>IFSC Code</label>

                <input
                  type={"input"}
                  id={"ifsc_code"}
                  required
                  ref={(el) => (bankRef.current["ifsc_code"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <br />
              <div className="form-group">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={submitBankDetails}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <hr />
          <div className="flexRow">
            <table className="table table-bordered text-center table-sm">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {bankDetails &&
                  bankDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>

                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => handleDeleteBank(i, e)}
                          >
                            delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="btn btn-sm btn-primary"
              onClick={() => {
                bankDetails && bankDetails.map((x) => (x["isSave"] = true));
                setBankClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* bank modal end */}
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Employee Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-5">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="160"
                          height="160"
                          alt="User Image"
                        />

                        <div className="input-group">
                          <div className="custom-file">
                            <label style={{ cursor: "pointer" }}>
                              <input
                                type="file"
                                className="custom-file-input"
                                id="file"
                                accept="image/*"
                                onChange={uploadProImage}
                              />
                              Upload
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"employee_name"}>
                          {"Employee Name"}
                        </label>
                        <input
                          type="text"
                          id="employee_name"
                          className="form-control"
                          ref={(el) => (frmRef.current["employee_name"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                      <div className="form-group"></div>
                      <div className="form-group">
                        <label htmlFor={"whatsapp_number"}>
                          {"Whatsapp Number"}
                        </label>
                        <input
                          type={"text"}
                          id={"whatsapp_number"}
                          required
                          ref={(el) => (frmRef.current["whatsapp_number"] = el)}
                          className="form-control"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor={"joining_date"}>
                          {"Date of Joining"}
                        </label>
                        <input
                          type="date"
                          id="joining_date"
                          className="form-control"
                          ref={(el) => (frmRef.current["doj"] = el)}
                          autoComplete="off"
                          required
                          max={currentDate}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"employee_type"}>
                          {"Employee Type"}
                        </label>

                        <select
                          id="employee_type"
                          className="form-control"
                          ref={(el) => (frmRef.current["employee_type"] = el)}
                          required
                          onChange={(e) => {
                            if (e.target.value != "Select")
                              setEmpType(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          <option>Labour </option>
                          <option>Employee </option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={"location"}>{"Location"}</label>
                        <select
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["location"] = el)}
                          autoComplete="off"
                          required
                        >
                          <option value="">Select</option>
                          {locationData &&
                            locationData.map((x) => (
                              <option
                                key={x.id}
                                value={x.id}
                                selected={
                                  props.update &&
                                  x.id === props.update.warehouseId
                                }
                              >
                                {x.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label htmlFor={"work_email"}>{"Work Email"}</label>
                        <input
                          type={"email"}
                          id={"work_email"}
                          ref={(el) => (frmRef.current["work_email"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    {/* /.col */}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"email"}>{"Email id"}</label>
                        <input
                          type={"email"}
                          id={"email"}
                          ref={(el) => (frmRef.current["email"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"contact_no"}>{"Contact Number"}</label>
                        <input
                          type={"text"}
                          id={"contact_no"}
                          required
                          ref={(el) => (frmRef.current["contact_no"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"designation"}>{"Designation"}</label>
                        <select
                          id={"designation"}
                          required
                          ref={(el) => (frmRef.current["designation"] = el)}
                          className="form-control"
                          onChange={handleDesignationChange}
                        >
                          <option value="">Select</option>
                          {designationData &&
                            designationData.map((x) => (
                              <option
                                key={x.designationId}
                                value={x.designationId}
                                selected={
                                  props.update &&
                                  x.designationId === props.update.designationId
                                }
                              >
                                {x.designationName}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={"employment_type"}>
                          {"Employment Type"}
                        </label>

                        <select
                          id="employment_type"
                          className="form-control"
                          ref={(el) => (frmRef.current["employment_type"] = el)}
                          required
                        >
                          <option value="">Select</option>
                          <option>Permanent </option>
                          <option>Temporary </option>
                          <option>Contractual</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={"reporting_emp"}>
                          {"Reporting Employee"}
                        </label>
                        <select
                          type={"text"}
                          id={"reporting_emp"}
                          required
                          ref={(el) => (frmRef.current["reporting_emp"] = el)}
                          className="form-control"
                          autoComplete="off"
                          value={empId}
                          onChange={(e) => setEmpId(e.target.value)}
                        >
                          <option value="">Select</option>
                          {filteredEmployeeData &&
                            filteredEmployeeData.map((x) => (
                              <option key={x.empId} value={x.empId}>
                                {x.employeeName}
                              </option>
                            ))}{" "}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={"id_proof"}>{"ID Proof"}</label>
                        <select
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["id_proof"] = el)}
                          autoComplete="off"
                          required
                        >
                          <option value="">Select</option>
                          <option>Aadhar ID</option>
                          <option>Pan ID</option>
                          <option>Driving License</option>
                          <option>other</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={"bank_details"}>{"Bank Details"}</label>
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button
                          type={"button"}
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            setBankClose(true);
                            bankDetails &&
                              setBankDetails((items) =>
                                items.filter((x) => x.isSave)
                              );
                          }}
                        >
                          Add{" "}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"gender"}>{"Gender"}</label>

                        <select
                          id="gender"
                          className="form-control"
                          ref={(el) => (frmRef.current["gender"] = el)}
                          required
                        >
                          <option value="">Select</option>
                          <option>Male</option>
                          <option>Female</option>
                          <option>Other</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={"dob"}>{"Birth Date"}</label>
                        <input
                          type={"date"}
                          id={"dob"}
                          required
                          ref={(el) => (frmRef.current["dob"] = el)}
                          className="form-control"
                          max={currentDate}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"department"}>{"Department"}</label>
                        <select
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["department"] = el)}
                          autoComplete="off"
                          required
                        >
                          <option value="">Select</option>
                          {departmentData &&
                            departmentData.map((x) => (
                              <option
                                key={x.departmentId}
                                value={x.departmentId}
                                selected={
                                  props.update &&
                                  x.departmentId === props.update.departmentId
                                }
                              >
                                {x.departmentName}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>
                          {empType == "Labour"
                            ? "Per Day Wages"
                            : "Gross Salary"}
                        </label>

                        <input
                          type={"text"}
                          id={"grossSalary"}
                          required
                          ref={(el) => (frmRef.current["grossSalary"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"work_contact"}>
                          {"Contact Number(Work)"}
                        </label>
                        <input
                          type={"text"}
                          id={"work_contact"}
                          ref={(el) => (frmRef.current["work_contact"] = el)}
                          className="form-control"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor={"address_details"}>
                          {"Address Details"}
                        </label>
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button
                          type={"button"}
                          id={"address_details"}
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            addressDetails &&
                              setAddressDetails((items) =>
                                items.filter((x) => x.isSave)
                              );
                            setClose(true);
                          }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EmployeeForm;
